module.exports = __webpack_public_path__ + "img/symbol_deleteblue.d5c1d37e.png";